import { render, staticRenderFns } from "./StudentGraduation.vue?vue&type=template&id=3fbf6daf&scoped=true"
import script from "./StudentGraduation.vue?vue&type=script&lang=js"
export * from "./StudentGraduation.vue?vue&type=script&lang=js"
import style0 from "./StudentGraduation.vue?vue&type=style&index=0&id=3fbf6daf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fbf6daf",
  null
  
)

export default component.exports